import GrilleTarifairesController from './grille.tarifaires.controller';

export default {
    template: require('./grille.tarifaires.html'),
    controller: GrilleTarifairesController
};
